import React from "react";
import { useSelector } from "react-redux";
import CartProduct from "../CartProduct/CartProduct";

const CartProducts = () => {

  const carts = useSelector(state => state.carts)

  return (
    <>
      <div className="space-y-6">
        {!carts.length && <p className="text-xl font-bold text-center">you haven't add any product in your cart yet.</p>}
        {
          carts.map(cart => <CartProduct key={cart.id} cart={cart}></CartProduct>)
        }
      </div>
    </>
  );
};

export default CartProducts;
